export function readJsonFromBlob(
  blob: Blob,
  onSuccess: (json: any) => void,
  onError: () => void
): void {
  const reader = new FileReader();

  reader.onload = () => {
    try {
      const result = reader.result as string;
      const json = JSON.parse(result);
      onSuccess(json);
    } catch {
      onError();
    }
  };

  reader.onerror = () => {
    onError();
  };

  reader.readAsText(blob);
}
